export default __webpack_public_path__ + "static/media/P_M_R.d5a06d78.svg";